import React, { Component } from 'react';
import Question from './Question';

import './style.less';
import arrowAudio from '../../static/audio/arrow.mp3';
import showScoreAudio from '../../static/audio/showScore.mp3';

export default class Archery extends Component {
    constructor(props){
        super(props);
        this.clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
        this.countInit = 1600 / this.clientWidth;
        this.state = {
            currentIndex: 0,
            totalIndex: props.totalIndex,
            arrowStyle:'transform 0.3s ease-in',
        };
        this.timeOutArr = [];
    }

    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }

    componentWillReceiveProps(nextProps){
        this.setState(nextProps)
    }

    playResult = (score) => {
        this.setState({
            score: score >= 30 ? score : 30,
            playResult: true,
            arrowStyle:'transform 0.3s ease-in',
        });
        this.arrowAudio.play();
        this.timeOutArr.push(
            setTimeout(() => {
                this.setState({
                    showScore: true
                },()=>{
                    // this.arrowAudio.stop();
                    if(score > 30){
                        this.showScoreAudio.play()
                    }
                });
                this.timeOutArr.push(
                    setTimeout(() => {
                        this.setState({
                            showScore: false
                        });
                        // this.showScoreAudio.stop();
                    }, 2500)
                )
            }, 800)
        )
    }

    restart = () =>{
        this.setState({
            playResult: false,
            arrowStyle: 'none'
        });
    }

    // nextQuestion = () => {
    //     const { score } = this.state;
    //     this.props.nextQuestion(score);
    // }

    render(){
        const { currentIndex, totalIndex, showScore, score, playResult, arrowStyle } = this.state;
        const { questionInfo, completeRenderFun, level0 } = this.props;
        return(
            <div className="container homework_new archery">
                <div className={`hand ${playResult?'active':''}`}></div>
                <div 
                    className={`arrow ${playResult?'':'score0'} score${score > 30 ? score > 69 ? '3' : '2' : '1'}`} 
                    style={{transition:arrowStyle}} 
                />
                <Question 
                    parameters={this.props.parameters}
                    level0={level0}
                    type="archery" 
                    defaultStep={'step1'} 
                    defaultTime={3}
                    questionInfo={questionInfo}
                    isLast={Boolean(currentIndex === totalIndex)}
                    nextQuestion={this.props.nextQuestion}
                    playResult={this.playResult}
                    restart={this.restart}
                    completeRenderFun={completeRenderFun}
                    onStorageEvaluatedAudio={this.props.onStorageEvaluatedAudio}
                    ref={com => this.child = com} 
                />
                <audio preload='auto' ref={ com => {this.arrowAudio = com} } src={arrowAudio}></audio>
                <audio preload='auto' ref={ com => {this.showScoreAudio = com} } src={showScoreAudio}></audio>
                { !!showScore &&
                    <div className="score_shadow">
                        <div className={`score_wrap score${score > 30 ? score > 69 ? '3' : '2' : '1'} ${showScore?'active':''}`}>
                            <div className="score">{score/10}</div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/Archery.jsx